/**
 * 注文コードの正規化と比較。
 *
 * Shopify は注文番号を `#1234` 形式で返すが、Postgres ReturnRequest / Logiless / 比較ロジックでは
 * 先頭の `#` を含めない形を canonical とする (DB スキーマ・既存 Webhook 全てそう)。
 *
 * mypage 配下では生 `code.replace(/^#/, "")` を直接書かず、必ずこの helper を経由する。
 * ルーティングの URL slug 生成 (`/orders/:code`) や Logiless / Shopify 突合に使う。
 */

/** 先頭の `#` を除去した注文コード文字列を返す。 */
export const normalizeOrderCode = (code: string): string => code.replace(/^#/, "");

/** 2 つの注文コードを `#` の有無に依らず比較する。 */
export const orderCodesEqual = (a: string, b: string): boolean =>
  normalizeOrderCode(a) === normalizeOrderCode(b);
